import React from 'react';
import Modal from 'react-bootstrap/Modal';

import AsyncSelect from "react-select/async";
import { reactSelectIcons } from "../../util/reactSelectPrimeIcons";
import { asyncSelectCustomStyles } from "../../util/styles";

import './Style.css';

class ModalAvaliacao extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            motivosSelecionados: [],
            form: {
                base_id: '',
                motivos: [],
                comentario: null,
            },
        };
    }

    debounce = (key, callback, delay = 250) => {
        clearTimeout(this.searchTimeouts[key]);

        this.searchTimeouts[key] = setTimeout(() => {
            callback();
        }, delay);
    };

    handleInputChange = (event) => {
        const {
            name,
            value,
        } = event.target;

        this.setState({
            form: {
                ...this.state.form,
                [name]: value,
            },
        });
    };

    searchMotivos = async (inputValue) => {
        if (!inputValue || inputValue.length < 3) {
            return [];
        }

        try {
            const response = await axios.get(
                `/autocomplete-motivos`,
                {
                    params: {
                        search: inputValue,
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error('Erro ao buscar motivos:', error);
            return [];
        }
    };

    handleMotivosChange = (selectedOptions) => {
        this.setState({
            motivosSelecionados: selectedOptions || [],
            form: {
                ...this.state.form,
                motivos: selectedOptions,
            },
        });
    };

    handleSubmit = async (event) => {
        event.preventDefault();

        const {
            form,
        } = this.state;

        if (!form.motivos || form.motivos.length === 0) {
            alert('Selecione ao menos um motivo antes de continuar!');
            return;
        }

        const data = {
            ...form,
            base_id: this.props.onSelectedBaseToValidate,
        };

        await this.props.onSubmit(data);
    };

    handleClose = () => {
        if (this.props.loading) {
            return;
        }

        this.setState({
            form: {
                base_id: '',
                motivos: [],
                comentario: null,
            },
        });

        this.props.onClose();
    };

    render() {

        const {
            open,
            loading,
        } = this.props;

        const {
            form,
        } = this.state;

        return (
            <div style={{ zIndex: '9999' }}>
                <Modal
                    show={ open }
                    onHide={ this.handleClose }
                    dialogClassName="modal-avaliacao"
                    size="lg"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Avaliação
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <form
                            className="form-modal"
                            onSubmit={ this.handleSubmit }
                        >
                            <div className="formulario">
                                <div className="form-group">
                                    <label>Motivo / Critério</label>
                                    <AsyncSelect
                                        isMulti
                                        closeMenuOnSelect={ false }
                                        value={ form.motivos }
                                        loadOptions={ this.searchMotivos }
                                        getOptionLabel={(option) => option.text}
                                        getOptionValue={(option) => String(option.id)}
                                        onChange={ this.handleMotivosChange }
                                        styles={ asyncSelectCustomStyles }
                                        placeholder="Selecione"
                                        components={ reactSelectIcons }
                                        noOptionsMessage={() => "Digite para buscar..."}
                                        loadingMessage={() => 'Carregando...'}
                                        className="autocomplete"
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Comentário</label>
                                    <textarea
                                        className=""
                                        placeholder="Digite"
                                        rows="3"
                                        cols="3"
                                        name="comentario"
                                        onChange={
                                            this.handleInputChange
                                        }
                                    >{ form.comentario }</textarea>
                                </div>

                                <div className="form-buttons">
                                    <button
                                        type="submit"
                                        className="btn btn-success btn-round background-brain"
                                    >
                                        {loading ? (
                                            <>
                                                <i className="fa fa-spinner fa-spin"></i>{' '}
                                                Processando...
                                            </>
                                        ) : (
                                            'Salvar'
                                        )}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default ModalAvaliacao;